<script>
    import { onMount } from 'svelte';

    export let available_reservations = [];

    let selectedIndex = available_reservations ? getStartingIndex() : 0;

    export let selectedTime = available_reservations[selectedIndex];

    function getStartingIndex() {
        let i = 0;
        if(!available_reservations[i]) {
            return 0;
        }

        while(available_reservations[i].available != true)
        {
            if(i + 1 >= available_reservations.length) {
                return 0;
            }
            else 
                i++;
        }

        return i;
    }

    onMount(() => {
        selectedIndex = 0;
        selectedTime = available_reservations[0];
    });
</script>

{#if available_reservations}
{#if available_reservations.length > 0}
<div class="t_container">
    {#each available_reservations as d, i}
    <button 
        class="timeButton" 
        class:selected={i == selectedIndex} 
        disabled={!d['available']}
        on:click|preventDefault={()=>{
            selectedIndex=i;
            selectedTime=available_reservations[selectedIndex]; 
        }}
        >
        <!-- {d.start_time.split(" ")[1].split(":").slice(0, 2).join(":")} -->
        {new Date(d.start_time).toLocaleDateString('cs-CZ', {})} - Kapacita {d.reserved_count} / {d.capacity} 
    </button>
    {/each}
</div>
{:else}
<div style="background-color: #FFE5B4; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #FFA07A; margin-bottom: 20px;">
    <strong>Upozornění:</strong> Služba není ve vybraný den dostupná. Vyberte prosím jiné datum.
</div>
{/if}
{:else}
<div style="background-color: #FFE5B4; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #FFA07A; margin-bottom: 20px;">
    <strong>Upozornění:</strong> Služba není ve vybraný den dostupná. Vyberte prosím jiné datum.
</div>
{/if}

<style>
    .t_container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
    }   

    button.timeButton {
        width: 20%;
    }

    button.timeButton.selected {
        background-color: #cacaca !important;
    }

    button.timeButton[disabled] {
        background-color: #ff2a00 !important;
    }
</style>